import React, {useState, useEffect} from 'react';
import {duckify, filterDuck, singleDuck} from 'utils/duckify';
import {
  checklistAnswerLinks,
  commonForms as commonFormsDuck, modals,
} from 'ducks';
import {compose} from "redux";
import ModalComponent from "components/ModalComponent";
import {Button} from "react-bootstrap";

const ChecklistAnswerLinker = ({allDucksReady, commonForms, checklistAnswerId, currentItemDescription, dispatch}) => {
  const [selectedForm, selectForm] = useState(undefined);
  const [page, setPage] = useState(1);

  const onClick = () => {
    if (page === 1) {
      setPage(2)
    } else if (page === 2) {
      setPage(1)
    }
  }

  const onSubmit = () => {
    dispatch(checklistAnswerLinks.actions.create("checklist_answer", {
      original_checklist_answer_id: selectedForm.id,
      checklist_answer_id: checklistAnswerId
    }))
      .then(() => { window.location.reload(false); })
        .catch((e) => {
        dispatch(modals.actions.hide())
        dispatch(modals.actions.show('UnexpectedError'))
      })
  }

  const modalText = page === 1 ?
    <div> The dropdown below shows all common forms that you have previously submitted or requested at other schools
      that
      are eligible to be linked to this checklist item. Choose the appropriate form and click “Next” to proceed.
      Once the form is linked, it will automatically be sent to the school and the checklist item will be
      completed.</div> :
    <div>Are you sure you would like to link the selected form to this checklist item? Please review your selection
      below and click “Save” to link the checklist item or “Previous” to change your selection.</div>

  const buttonTitle = page === 1 ? 'Next' : 'Previous';
  const buttons = [
    <Button
      className={`btn ${page === 1 ? 'btn-primary' : ''}`}
      disabled={!selectedForm}
      onClick={() => onClick()}
    >
      {buttonTitle}
    </Button>
  ];

  if (page !== 1) {
    buttons.push(<Button className='btn btn-primary' onClick={() => onSubmit()}>Submit</Button>);
  }

  return <ModalComponent title='Link Common Form' buttons={buttons} className={'checklist-item-linker'}>
    {modalText}
    <div><h2>Current Checklist Item Details</h2>
      {currentItemDescription}
    </div>

    <h2>Linked Checklist Item Details</h2>

    {commonForms.length === 0 && <div>There are currently no common forms available to be linked.</div>}

    {allDucksReady && commonForms.length !== 0 && page === 1 &&
    <select id="checklist_answer_link_select" value={selectedForm && selectedForm.id}
            onChange={(e) => selectForm(commonForms.filter(f => f.id === e.target.value)[0])}>
      <option>Select form to link</option>
      {commonForms.length > 0 && commonForms.map((form) => <option value={form.id}> {form.form_description} </option>)}
    </select>
    }

    {page === 2 && selectedForm.form_description}
  </ModalComponent>
}

const mapDucksToProps = (props) => {
  return {
    commonForms: filterDuck(
      commonFormsDuck, {
        checklist_answer_id: props.checklistAnswerId,
        checklist_request_item: props.checklistRequestItem,
      }
    )
  };
};

export default compose(duckify(mapDucksToProps))(ChecklistAnswerLinker);
